import { render } from "./BiaPackPicker.vue?vue&type=template&id=1fc7ddc3&scoped=true"
import script from "./BiaPackPicker.vue?vue&type=script&lang=js"
export * from "./BiaPackPicker.vue?vue&type=script&lang=js"

import "./BiaPackPicker.vue?vue&type=style&index=0&id=1fc7ddc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc7ddc3"]])

export default __exports__